import React, { Component } from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import { connect } from 'react-redux'
import { CSVLink, CSVDownload } from 'react-csv';
import { Button } from 'react-materialize'


class TableChart extends Component {
  constructor(props) {
    super(props)
    this.state = {
      allData_CSV: []
    };
  }

  componentWillMount(){
    var allData_CSV = [["Country", "Age", "Gender", "Year", "Value"]]
    this.props.allData.forEach( data => {
        allData_CSV.push([ data.country, `'${data.age}'`, data.gender, data.sample_year, data.value])
    })
    this.setState({ allData_CSV: allData_CSV })

  }

  render() {
    var table_data = [];
    const { data, gender, age, yearBound, countries } = this.props
    const { allData_CSV } = this.state
    console.log("this.props", this.props)
    var age_str = age.map( x => x.toString())
    data.forEach( document => {
      document.sample_year = parseInt(document.sample_year);
      //document.value = this.round(document.value, 1)
      if(document.sample_year <= yearBound[1] && document.sample_year >= yearBound[0] && gender.includes(document.gender) && age_str.includes(`${document.age}`) && countries.includes(document.country)){
        table_data.push(document);
      }
    })


     const columns = [
          {
            Header: 'Country',
            accessor: 'country',
            headerClassName: 'table-left-header',
            className: 'table-left-header' // String-based value accessors!
          },
          {
            Header: 'Age',
            accessor: 'age',
            headerClassName: 'hdrCls',
            className: 'table-center-header' // String-based value accessors!
           },
           {
            Header: 'Gender',
            accessor: 'gender',
            className: 'table-center-header' // String-based value accessors!
           },
           {
             Header: 'Year',
             accessor: 'sample_year',
             className: 'table-center-header' // String-based value accessors!
            },
            {
              Header: 'Value',
              accessor: 'value',
              headerClassName: 'table-right-header',
              className: 'table-right' // String-based value accessors!
             } ]


  /* showPagination={false}
  defaultPageSize={table_data.length} */
  var csv = [["Country", "Age", "Gender", "Year", "Value"]]

  if(table_data){
    table_data.forEach( data => {
      csv.push([ data.country, `'${data.age}'`, data.gender, data.sample_year, data.value])
    })
  }



  return (
    <div className="table">
      <ReactTable
        className="-striped -highlight"
        data={table_data}
        columns={columns}
        showPagination={false}
        defaultPageSize={table_data.length}
        style={{
            height: "590px"
          }}
        defaultSorted={[
           {
             id: "country",
             desc: false
           }
         ]}
      />
      <br/>
      <div className="pulled-right">
        <Button><CSVLink style={{color: "white"}} data={csv} >Download CSV</CSVLink></Button>
        &nbsp;&nbsp;&nbsp;
        <Button><CSVLink style={{color: "white"}} data={allData_CSV} >Download all Data</CSVLink></Button>
      </div>
    </div>
  )}
}

function mapStateToProps(state){
  return {
    allData: state.data,
    data: state.data,
    gender: state.gender,
    yearBound: state.yearBound,
    countries: state.countries,
    age: state.age
    }
};


export default connect(mapStateToProps)(TableChart);



// WEBPACK FOOTER //
// ./src/components/TableChart.js